import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/theme.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";
import { BrowserClient } from "@sentry/browser"; 
import 'inter-ui/inter.css';
import GlobalStyle from "./GlobalStyle";
import ErrorPage from "./components/Common_Components/ErrorPage";
import WorkspaceProvider from "./contexts/WorkspaceContext";
import './constants/setupInterceptors'
import { viPostMessage } from './utils/nativePermissions'

const root = ReactDOM.createRoot(document.getElementById("root"));
// Initialize Sentry
const sentryDsn = process.env.REACT_APP_SENTRY_URL;
const sourceUrl = process.env.REACT_APP_SOURCE_URL;
if(sourceUrl){
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ], // Use BrowserClient
    tracesSampleRate: 1.0, // Adjust as needed for production
  });
}

window.onerror = function(message, source, lineno, colno, error) {
  console.error('Global error:', { message, source, lineno, colno, error });
  viPostMessage('js_error', { message, source, lineno, colno, stack: error?.stack });
};

window.onunhandledrejection = function(event) {
  console.error('Unhandled promise rejection:', event.reason);
  viPostMessage('promise_rejection', { reason: String(event.reason), stack: event.reason?.stack });
};

const handleError = (error, errorInfo) => {
  console.error('React ErrorBoundary caught:', error, errorInfo);
  viPostMessage('react_error', { message: error?.message, stack: error?.stack, componentStack: errorInfo?.componentStack });
};

const ErrorFallback = ({ error, componentStack }) => {
  return <ErrorPage error={error} errorInfo={{ componentStack }} />;
};

root.render(
  <Sentry.ErrorBoundary fallback={ErrorFallback} onError={handleError}>
    <GlobalStyle />
    <WorkspaceProvider>
    <App />
    </WorkspaceProvider>
  </Sentry.ErrorBoundary>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
